module.exports = __webpack_public_path__ + "static/youtube-logo-yatay-36c088ff25627fb6ce6d673d94787afe.png";